/**
 * Situação de uma conexão de WhatsApp, com rótulo e cor.
 *
 * Fica aqui, e não dentro de uma página, porque a mesma informação aparece na
 * tela de Conexões e nos cartões de Fluxos visuais. Duas cópias acabariam
 * divergindo -- uma página diria "Reconectando" em laranja e a outra em cinza.
 *
 * ATENÇÃO: o NOME da conexão é livre. Se alguém batizar de
 * "Consig - 1008 - desconectado", o texto do nome não quer dizer nada sobre o
 * estado real. A cor sempre vem de `status`, nunca do nome.
 */
export const SITUACAO = {
  CONNECTED: {
    rotulo: "Conectado",
    cor: "#1E9855",
    ajuda: "Recebendo e enviando mensagens.",
  },
  OPENING: {
    rotulo: "Reconectando",
    cor: "#f59e0b",
    ajuda: "Caiu e está voltando sozinha. Aguarde alguns segundos.",
  },
  PAIRING: {
    rotulo: "Pareando",
    cor: "#f59e0b",
    ajuda: "Terminando de vincular o aparelho.",
  },
  qrcode: {
    rotulo: "Aguardando QR",
    cor: "#2563eb",
    ajuda: "Leia o QR Code com o celular para conectar.",
  },
  TIMEOUT: {
    rotulo: "Sem resposta",
    cor: "#e53935",
    ajuda: "Travou esperando o aparelho. Precisa reiniciar.",
  },
  DISCONNECTED: {
    rotulo: "Desconectado",
    cor: "#e53935",
    ajuda: "A sessão foi encerrada. Só um QR Code novo reconecta.",
  },
};

const DESCONHECIDA = {
  rotulo: "Desconhecido",
  cor: "#667085",
  ajuda: "Estado não reconhecido.",
};

export const situacaoDaConexao = (status) =>
  SITUACAO[status] || { ...DESCONHECIDA, rotulo: status || "Desconhecido" };

/** true quando o estado exige alguém olhar (piscar o pontinho). */
export const exigeAcao = (status) =>
  status === "DISCONNECTED" || status === "TIMEOUT";

/** "5583996609667" -> "+55 (83) 99660-9667" */
export const formatarNumeroConexao = (bruto) => {
  const d = String(bruto || "").replace(/\D/g, "");
  if (!d) return "";
  if (d.length === 13) {
    return `+${d.slice(0, 2)} (${d.slice(2, 4)}) ${d.slice(4, 9)}-${d.slice(9)}`;
  }
  if (d.length === 12) {
    return `+${d.slice(0, 2)} (${d.slice(2, 4)}) ${d.slice(4, 8)}-${d.slice(8)}`;
  }
  return `+${d}`;
};
